export default function filterMonthlyRevenueData(data = [], filters = {}) {
  const {
    biddingTypeSelecionado = '',
    estado = '',
    anoSelecionado = new Date().getFullYear(),
  } = filters

  function getMonthKey(dateStr) {
    const date = new Date(dateStr)
    if (Number.isNaN(date.getTime()) || date.getFullYear() !== Number(anoSelecionado)) return null
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
  }

  const grouped = {}

  data.forEach(item => {
    if (biddingTypeSelecionado && item.biddingType !== biddingTypeSelecionado) return
    if (estado && item.stateName !== estado) return

    const key = getMonthKey(item.winningDate || item.date)
    if (!key) return

    if (!grouped[key]) {
      grouped[key] = {
        total: 0,
        totalPregoes: new Set(),
        totalItens: 0,
      }
    }

    grouped[key].total += item.contractCost || item.cost || 0
    if (item.nPregao) grouped[key].totalPregoes.add(item.nPregao)
    grouped[key].totalItens += item.itemCount || 1
  })

  const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
  const labels = months.map(month => `${month}/${anoSelecionado}`)

  const totalPerMonth = []
  const acumulado = []
  const ticketPorPregao = []
  const ticketPorItem = []
  const variacaoPercentual = []

  let runningTotal = 0
  let i = 0
  while (i < 12) {
    const key = `${anoSelecionado}-${String(i + 1).padStart(2, '0')}`
    const group = grouped[key]

    const total = group ? group.total : 0
    const pregCount = group ? group.totalPregoes.size : 0
    const itemCount = group ? group.totalItens : 0

    totalPerMonth.push(total)

    runningTotal += total
    acumulado.push(runningTotal)

    ticketPorPregao.push(pregCount > 0 ? total / pregCount : 0)
    ticketPorItem.push(itemCount > 0 ? total / itemCount : 0)

    if (i === 0) {
      variacaoPercentual.push(0)
    } else {
      const prev = totalPerMonth[i - 1]

      if (prev === 0) {
        variacaoPercentual.push(null) // ou 0 se preferir
      } else {
        let variacao = ((total - prev) / prev) * 100

        // Limita variação entre -100% e +100%
        variacao = Math.max(-100, Math.min(variacao, 100))

        variacaoPercentual.push(variacao)
      }
    }

    i += 1
  }

  return {
    labels,
    datasets: [
      {
        label: 'Receita Total (R$)',
        backgroundColor: '#4CAF50',
        data: totalPerMonth,
        yAxisID: 'y-receita',
      },
      {
        label: 'Acumulado (R$)',
        backgroundColor: '#2196F3',
        type: 'line',
        fill: false,
        borderColor: '#2196F3',
        data: acumulado,
        yAxisID: 'y-receita',
      },
      {
        label: 'Variação (%)',
        backgroundColor: '#FFC107',
        type: 'line',
        fill: false,
        borderColor: '#FFC107',
        data: variacaoPercentual.map(v => (v === null ? null : Number(v.toFixed(2)))),
        yAxisID: 'y-porcentagem',
      },
      {
        label: 'Ticket Médio por Pregão',
        backgroundColor: '#9C27B0',
        type: 'line',
        fill: false,
        borderColor: '#9C27B0',
        data: ticketPorPregao,
        yAxisID: 'y-receita',
      },
      {
        label: 'Ticket Médio por Item',
        backgroundColor: '#FF5722',
        type: 'line',
        fill: false,
        borderColor: '#FF5722',
        data: ticketPorItem,
        yAxisID: 'y-receita',
      },
    ],
  }
}
